import { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { FaSpinner } from "react-icons/fa"; // Loading spinner icon

const Blog = () => {
  const [mainBlog, setMainBlog] = useState(null);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loadingBlogs, setLoadingBlogs] = useState(true);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [errorBlogs, setErrorBlogs] = useState(false);
  const [errorCategories, setErrorCategories] = useState(false);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const { data: blogsData } = await axios.get("https://backendadmin.azwaaja.com/api/blogs");
        const mainBlog = blogsData.find(blog => blog.isMain);
        const recentBlogs = blogsData.filter(blog => !blog.isMain).slice(0, 6);

        setMainBlog(mainBlog);
        setRecentBlogs(recentBlogs);
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setErrorBlogs(true);
      } finally {
        setLoadingBlogs(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const { data: categoriesData } = await axios.get("https://backendadmin.azwaaja.com/api/categories");
        setCategories(categoriesData);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setErrorCategories(true);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchBlogs();
    fetchCategories();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const optionsDate = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString(undefined, optionsDate);
  };


  return (
    <Fragment>
      <div className="blog-section padding-top padding-bottom">
        <div className="container">
          <div className="section-wrapper">
            <div className="row g-4 justify-content-center">
              {loadingBlogs ? (
                <div className="min-h-screen flex items-center justify-center">
                  {/* Loading spinner or animation */}
                  <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
                </div>
              ) : errorBlogs ? (
                <div className="text-center text-red-600">Error loading blogs. Please try again later.</div>
              ) : 
                mainBlog && (
                <div className="col-12 mb-8">
                  <div className="">
                    <div className="flex flex-col xl:flex-row items-center justify-between">
                      <div className="blog__thumb w-full xl:w-1/2 mb-4 xl:mb-0">
                        <Link to={`/blog/${mainBlog._id}`}>
                          <motion.div
                            initial={{ x: -100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ duration: 0.8, delay: 0.3 }}
                            className="w-full h-auto overflow-hidden"
                          >
                            <img
                              src={`${mainBlog.image}`}
                              alt={`${"image"}`}
                              className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                            />
                          </motion.div>
                        </Link>
                      </div>
                      <div className="blog__content p-4 xl:ps-5 w-full xl:w-1/2">
                        <Link to={`/blog/${mainBlog._id}`}>
                          <h3 className="font-normal text-2xl xl:text-4xl mb-3 text-black">
                            {mainBlog.title}
                          </h3>
                        </Link>
                        <p className="text-sm">{mainBlog.excerpt}</p>
                        <div className="blog__metapost uppercase tracking-widest font-normal mt-3">
                          <a href="#" className="text-black">
                            <span className="text-gray-600">By</span> Azwaaja Team
                          </a>
                        </div>
                        <p
                          className="text-gray-600 text-sm tracking-widest mt-1 block"
                        >
                          {formatDate(mainBlog.publishDate)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <h1 className="tracking-widest text-sm uppercase text-gray-600 mb-28">
                Be a Better Muslim
              </h1>

              <h1 className="text-2xl tracking-wider font-semibold text-black">
                Most Popular Stories
              </h1>
              {recentBlogs.map((val, i) => (
                <motion.div
                  initial={{ x: -100, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.3 }}
                  className="col-xl-4 col-md-6 col-12"
                  key={i}
                >
                  <div className="">
                    <div className="">
                      <div className="blog__thumb">
                        <Link
                          to={`/blog/${val._id}`}
                          className="h-[250px] w-[500px]"
                        >
                          <img
                            src={`${val.image}`}
                            alt={`${"image"}`}
                            className="object-contain rounded-lg hover:scale-110 transition-transform duration-300"
                          />
                        </Link>
                      </div>
                      <div className="blog__content px-3">
                        <p
                          className="mb-2 uppercase tracking-wide text-sm"
                        >
                          {formatDate(val.publishDate)}
                        </p>
                        <Link to={`/blog/${val._id}`}>
                          <h3 className="font-normal text-2xl mb-1 text-black">
                            {val.title}
                          </h3>
                        </Link>
                        <div className="">
                          <p
                            className="uppercase tracking-wide text-sm"
                          >
                            By Azwaaja Team
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}

              <h1 className="text-2xl tracking-wider text-center font-semibold text-black mt-8">
                Categories
              </h1>
              <div className="flex items-center justify-center flex-wrap gap-2 mt-4">
                {categories.map((category, i) => (
                  <Link to={`/blogs/${category.name}`}
                    key={i}
                    className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-medium"
                  >
                    {category.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Blog;
